import { Button } from "@mui/material";
import colors from "../lib/colors";
import { ArrowCircleRightOutlined } from "@mui/icons-material";

export const ExternalLinkButton = (props: any) => (
    <Button target="_blank" sx={{ color: colors.greyDarker, borderRadius: "16px", background: colors.greyLightest, height: "100%", padding: "0 16px", width: "100%" }} href={props.href} endIcon={<ArrowCircleRightOutlined />} >
        {props.children}
    </Button>
);